import React, { useState } from "react";
import { Heating } from "src/modules/fithub-shared/interfaces/workout";
import { Area, AreaContainer, Content, Wrapper } from "../crossfit/styles";
import MWProps from "../interfaces";

const HeatingComp: React.FC<MWProps<Heating>> = (props) => {
  const [text, setText] = useState(props.content.instructions);

  function onInteract() {
    if (props.content.instructions !== text) {
      props.onChange({ instructions: text });
    }
  }

  return (
    <Wrapper>
      <Content>
        <p>Informações para Aquecimento</p>
        <AreaContainer>
          <Area
            placeholder="Digite aqui as informações..."
            value={text}
            onChange={(e) => setText(e.target.value)}
            onMouseLeave={onInteract}
            onBlur={onInteract}
          />
        </AreaContainer>
      </Content>
    </Wrapper>
  );
};

export default HeatingComp;
